import React from 'react';
import PropTypes from 'prop-types';
import { usePrefs, useRequestData } from 'wsm-common-data';

import GridContainer from './displayStyles/Grid';
import CarouselContainer from './displayStyles/Carousel';
import TilesCarouselContainer from './displayStyles/TilesCarousel';
import LargeVehicleContainer from './displayStyles/Large';
import MobileCarousel from './displayStyles/MobileCarousel';
import MobileMiniGrid from './displayStyles/MobileMiniGrid';
import ResponsiveContainer from './displayStyles/Responsive';

export const BodyStyleContainer = ({ vehiclesArray }) => {
	const { deviceType } = useRequestData();
	const { displayStyle } = usePrefs();

	const props = {
		vehicles: vehiclesArray
	};

	const displayStyles = {
		grid: GridContainer,
		carousel: CarouselContainer,
		tilesCarousel: TilesCarouselContainer,
		largeVehicle: LargeVehicleContainer,
		responsive: ResponsiveContainer
	};

	let ComponentToRender;

	// On MOBILE the widget historically force-routes every display style into
	// the MobileCarousel. The container-aware `responsive` style is the sole
	// exception: the drawer is a MOBILE surface, so `responsive` must survive
	// there to render its own layout. `tilesCarousel` is the other: its mobile
	// counterpart is the paged tile mini-grid. All other styles keep the
	// carousel.
	if (deviceType === 'MOBILE' && displayStyle === 'tilesCarousel') {
		ComponentToRender = MobileMiniGrid;
	} else if (deviceType === 'MOBILE' && displayStyle !== 'responsive') {
		ComponentToRender = MobileCarousel;
	} else {
		ComponentToRender = displayStyles[displayStyle] || GridContainer;
	}

	return (
		<div data-testid="tabbed-model-selector">
			<ComponentToRender {...props} />
		</div>
	);
};

BodyStyleContainer.propTypes = {
	vehiclesArray: PropTypes.arrayOf(
		PropTypes.shape({
			year: PropTypes.number,
			make: PropTypes.string,
			model: PropTypes.string,
			modelInv: PropTypes.string,
			gvBodyStyle: PropTypes.string,
			image: PropTypes.string,
			inventoryCount: PropTypes.number,
			minStartingAtPrice: PropTypes.number
		})
	).isRequired
};

BodyStyleContainer.defaultProps = {};
